(function () {
  function initAnnouncement() {
    var root = document.querySelector("[data-ob-announcement]");
    if (!root) return;
    var raw = root.getAttribute("data-messages") || "";
    var messages = raw.split("||").map(function (m) { return m.trim(); }).filter(Boolean);
    if (!messages.length) return;
    var el = root.querySelector("[data-ob-announcement-msg]");
    if (!el) return;
    var i = 0;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || messages.length < 2) return;
    setInterval(function () {
      i = (i + 1) % messages.length;
      el.classList.remove("ob-announcement__msg");
      void el.offsetWidth;
      el.textContent = messages[i];
      el.classList.add("ob-announcement__msg");
    }, 3500);
  }

  function initHeroCarousel() {
    var root = document.querySelector("[data-ob-hero-carousel]");
    if (!root) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-ob-slide]"));
    var dots = Array.prototype.slice.call(root.querySelectorAll("[data-ob-dot]"));
    var badge = root.querySelector("[data-ob-badge]");
    var audience = root.querySelector("[data-ob-audience]");
    if (slides.length < 2) return;

    var index = 0;
    var paused = false;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function show(i) {
      index = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle("is-active", n === index);
        s.setAttribute("aria-hidden", n === index ? "false" : "true");
      });
      dots.forEach(function (d, n) {
        d.classList.toggle("is-active", n === index);
        d.setAttribute("aria-current", n === index ? "true" : "false");
      });
      var active = slides[index];
      if (badge) badge.textContent = active.getAttribute("data-title") || "";
      if (audience) audience.textContent = active.getAttribute("data-audience") || "";
    }

    var prev = root.querySelector("[data-ob-prev]");
    var next = root.querySelector("[data-ob-next]");
    if (prev) prev.addEventListener("click", function () { show(index - 1); });
    if (next) next.addEventListener("click", function () { show(index + 1); });
    dots.forEach(function (d, n) {
      d.addEventListener("click", function () { show(n); });
    });

    root.addEventListener("mouseenter", function () { paused = true; });
    root.addEventListener("mouseleave", function () { paused = false; });

    if (!reduce) {
      setInterval(function () {
        if (!paused) show(index + 1);
      }, 4500);
    }

    show(0);
  }

  function initMobileNav() {
    var openBtn = document.querySelector("[data-ob-nav-open]");
    var drawer = document.querySelector("[data-ob-drawer]");
    if (!openBtn || !drawer) return;
    var closeBtns = drawer.querySelectorAll("[data-ob-nav-close]");

    function setOpen(open) {
      drawer.setAttribute("data-open", open ? "true" : "false");
      document.documentElement.style.overflow = open ? "hidden" : "";
    }

    openBtn.addEventListener("click", function () { setOpen(true); });
    closeBtns.forEach(function (btn) {
      btn.addEventListener("click", function () { setOpen(false); });
    });
  }

  function initEditorialAssets() {
    var mapEl = document.getElementById("ob-editorial-assets");
    if (!mapEl) return;
    var map = {};
    try { map = JSON.parse(mapEl.textContent || "{}"); } catch (e) { return; }
    document.querySelectorAll("img[data-ob-asset]").forEach(function (img) {
      var key = img.getAttribute("data-ob-asset");
      if (key && map[key]) {
        img.src = map[key];
        img.removeAttribute("data-ob-asset");
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAnnouncement();
    initHeroCarousel();
    initMobileNav();
    initEditorialAssets();
  });
})();
